import React from 'react'

import data from '../data/data'

const Notification = () => {
    return <div className='notification'>
        {data.notification.content}
    </div>
}

export default Notification